import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    title: 'Guía rápida para detectar fallas eléctricas',
    description: 'Para saber rápidamente qué revisar cuando algo no funciona en casa.'
  }, {
    title: 'Herramientas eléctricas para el hogar',
    description: 'Las herramientas que deberías tener y para qué sirve cada una.'
  }, {
    title: 'Planos eléctricos básicos',
    description: 'Cómo entender planos eléctricos simples del hogar sin ser ingeniero.'
  }];
  return <section className="py-0 bg-white px-4 relative overflow-hidden" data-id="element-16">
      <div className="absolute right-0 top-0 w-1/2 h-full bg-brand-50 blur-[100px] pointer-events-none" data-id="element-17" />
      <div className="absolute left-0 bottom-0 w-1/3 h-1/2 bg-accent-50 blur-[100px] pointer-events-none" data-id="element-18" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-19">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-20">
          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-4 text-gray-900" data-id="element-21">
            🎁 LOS 3 BONOS
          </h2>
          <p className="text-xl text-gray-600" data-id="element-22">
            Material complementario para hacerte la vida aún más fácil.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-23">
          {bonuses.map((bonus, index) => <motion.div key={index} className="bg-white rounded-3xl p-8 border border-brand-100 shadow-lg shadow-brand-100/50 relative group hover:-translate-y-2 transition-transform duration-300" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-24">
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-brand-50 rounded-full blur-xl group-hover:bg-brand-100 transition-colors" data-id="element-25" />

              <div className="w-14 h-14 bg-brand-50 rounded-2xl flex items-center justify-center mb-6 border border-brand-100 shadow-sm relative z-10" data-id="element-26">
                <Gift className="w-7 h-7 text-brand-500" data-id="element-27" />
              </div>

              <div className="text-brand-500 font-bold text-sm tracking-widest uppercase mb-3 relative z-10" data-id="element-28">
                Bono {index + 1}
              </div>
              <h3 className="text-xl font-heading font-bold text-gray-900 mb-3 relative z-10" data-id="element-29">
                {bonus.title}
              </h3>
              <p className="text-gray-600 relative z-10 mb-4" data-id="element-30">
                {bonus.description}
              </p>

              <div className="relative z-10 flex items-center gap-3 mt-auto pt-4 border-t border-brand-100" data-id="element-31">
                <span className="text-gray-400 line-through text-lg font-semibold" data-id="element-32">
                  $9.990
                </span>
                <span className="text-brand-600 font-extrabold text-xl font-heading" data-id="element-33">
                  HOY GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}